/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LookupEntity,
} from '../models/index';
import {
    LookupEntityFromJSON,
    LookupEntityToJSON,
} from '../models/index';

export interface GetConfigValuesRequest {
    config: string;
}

/**
 * 
 */
export class LookupConfigApi extends runtime.BaseAPI {

    /**
     * Creates request options for getConfigTypes without sending the request
     */
    async getConfigTypesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/internal/config-types`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of supported configuration types
     * Get available Config types
     */
    async getConfigTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.getConfigTypesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns list of supported configuration types
     * Get available Config types
     */
    async getConfigTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getConfigTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getConfigValues without sending the request
     */
    async getConfigValuesRequestOpts(requestParameters: GetConfigValuesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['config'] == null) {
            throw new runtime.RequiredError(
                'config',
                'Required parameter "config" was null or undefined when calling getConfigValues().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['config'] != null) {
            queryParameters['config'] = requestParameters['config'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/internal/config`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns config values for the given type
     * Get config values by type
     */
    async getConfigValuesRaw(requestParameters: GetConfigValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LookupEntity>>> {
        const requestOptions = await this.getConfigValuesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupEntityFromJSON));
    }

    /**
     * Returns config values for the given type
     * Get config values by type
     */
    async getConfigValues(requestParameters: GetConfigValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LookupEntity>> {
        const response = await this.getConfigValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
